import { render, staticRenderFns } from "./erServerSidePaginationTable.vue?vue&type=template&id=63496752&"
import script from "./erServerSidePaginationTable.vue?vue&type=script&lang=js&"
export * from "./erServerSidePaginationTable.vue?vue&type=script&lang=js&"
import style0 from "./erServerSidePaginationTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports